<template lang="pug">
div
  el-row
    el-col(:span="24")
      app-resumo-cadastrante(:cadastrante="cadastro.cadastrante")
      app-resumo-interessado(
        :interessado="cadastro.interessado",
        :hasConjuge="hasConjuge()"
        :idCadastro="idCadastro",
        :isLiberacao="true"
      )
      resumo-imovel(
        v-if="cadastro"
        :imovel="cadastro.imovel"
        :idCadastro="idCadastro"
        :hasFieldsExtras="false"
      )

</template>
<script>
import AppResumoCadastrante from '@/components/resumo/AppResumoCadastrante'
import AppResumoInteressado from '@/components/resumo/AppResumoInteressado'
import AppResumoImovel from '@/components/resumo/AppResumoImovel'
import AppResumoGeo from '@/components/resumo/AppResumoGeo.vue'
import ResumoImovel from './ResumoImovel.vue'

import AppButton from '@/components/shared/AppButton'

export default {
  components: {
    AppButton,
    AppResumoCadastrante,
    AppResumoInteressado,
    AppResumoImovel,
    AppResumoGeo,
    ResumoImovel
  },

  props: ['cadastro', 'idCadastro'],

  methods: {
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    hasConjuge () {
      if (this.isMaranhao()) {
        if ([undefined, null].includes(this.cadastro.interessado.conjuge)) {
          return false
        }
      }
      return true
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/liberacao/components/Resumo.vue